/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createCustomerEphemeralKey = /* GraphQL */ `
  mutation CreateCustomerEphemeralKey(
    $input: CreateCustomerEphemeralKeyInput!
  ) {
    createCustomerEphemeralKey(input: $input) {
      id
      object
      associated_objects {
        id
        type
      }
      created
      expires
      livemode
      secret
    }
  }
`;
export const createPaymentIntent = /* GraphQL */ `
  mutation CreatePaymentIntent($input: CreatePaymentIntent!) {
    createPaymentIntent(input: $input) {
      secret
    }
  }
`;
export const fillOrder = /* GraphQL */ `
  mutation FillOrder($input: FillOrderInput!) {
    fillOrder(input: $input) {
      tradeTicketId
    }
  }
`;
export const closeOrder = /* GraphQL */ `
  mutation CloseOrder($input: CloseOrderInput!) {
    closeOrder(input: $input) {
      id
      accountId
      direction
      balanceAccountId
      balanceAccount {
        id
        accountId
        currency
        bondId
        createdAt
        updatedAt
      }
      bondId
      bond {
        id
        cusip
        isin
        currency
        issuerId
        couponPayment
        outstandingAmount
        minimumPiece
        minimumIncrement
        isSecRegisteredSecurity
        paymentRank
        couponType
        bidAmount
        offerAmount
        benchmark
        spreadToBenchmark
        accruedDays
        accruedInterest
        timezone
        interpolatedCDRate
        industry
        esgScore
        couponFrequency
        makeWholeCall
        createdAt
        updatedAt
      }
      faceAmount
      bondPrice
      minimumFillSize
      status
      statusLastChangeByUserId
      cancelReason
      isConfirmed
      confirmedByTraderId
      confirmedAt
      closingTradeTicketId
      tradeTickets {
        nextToken
      }
      appliedCommissionRate {
        amount
        rate
      }
      loadedYield
      isImmediate
      timeInForce
      expiresAt
      createdAt
      updatedAt
    }
  }
`;
export const addTestMoney = /* GraphQL */ `
  mutation AddTestMoney($input: AddTestMoneyInput!) {
    addTestMoney(input: $input) {
      id
      accountId
      previousTransactionId
      order
      transactedAt
      balanceAccountId
      balanceAccount {
        id
        accountId
        currency
        bondId
        createdAt
        updatedAt
      }
      source
      type
      amountChange
      disponibleAmountChange
      orderTicketId
      orderTicket {
        id
        accountId
        direction
        balanceAccountId
        bondId
        faceAmount
        bondPrice
        minimumFillSize
        status
        statusLastChangeByUserId
        cancelReason
        isConfirmed
        confirmedByTraderId
        confirmedAt
        closingTradeTicketId
        loadedYield
        isImmediate
        timeInForce
        expiresAt
        createdAt
        updatedAt
      }
      tradeTicketId
      tradeTicket {
        id
        accountId
        orderTicketId
        amount
        bondPrice
        accruedDays
        accruedInterest
        tradeDate
        settlementDate
        isClosed
        finalCommissionAmount
        loadedYield
        createdAt
        updatedAt
      }
      complementaryTransactionId
      balance
      disponibleBalance
      createdAt
      updatedAt
    }
  }
`;
export const createOrderTicketWithFundsReservation = /* GraphQL */ `
  mutation CreateOrderTicketWithFundsReservation(
    $input: CreateOrderTicketWithFundsReservationInput!
  ) {
    createOrderTicketWithFundsReservation(input: $input) {
      id
      accountId
      direction
      balanceAccountId
      balanceAccount {
        id
        accountId
        currency
        bondId
        createdAt
        updatedAt
      }
      bondId
      bond {
        id
        cusip
        isin
        currency
        issuerId
        couponPayment
        outstandingAmount
        minimumPiece
        minimumIncrement
        isSecRegisteredSecurity
        paymentRank
        couponType
        bidAmount
        offerAmount
        benchmark
        spreadToBenchmark
        accruedDays
        accruedInterest
        timezone
        interpolatedCDRate
        industry
        esgScore
        couponFrequency
        makeWholeCall
        createdAt
        updatedAt
      }
      faceAmount
      bondPrice
      minimumFillSize
      status
      statusLastChangeByUserId
      cancelReason
      isConfirmed
      confirmedByTraderId
      confirmedAt
      closingTradeTicketId
      tradeTickets {
        nextToken
      }
      appliedCommissionRate {
        amount
        rate
      }
      loadedYield
      isImmediate
      timeInForce
      expiresAt
      createdAt
      updatedAt
    }
  }
`;
export const createAccount = /* GraphQL */ `
  mutation CreateAccount(
    $input: CreateAccountInput!
    $condition: ModelAccountConditionInput
  ) {
    createAccount(input: $input, condition: $condition) {
      id
      owners
      users {
        nextToken
      }
      balanceAccounts {
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateAccount = /* GraphQL */ `
  mutation UpdateAccount(
    $input: UpdateAccountInput!
    $condition: ModelAccountConditionInput
  ) {
    updateAccount(input: $input, condition: $condition) {
      id
      owners
      users {
        nextToken
      }
      balanceAccounts {
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteAccount = /* GraphQL */ `
  mutation DeleteAccount(
    $input: DeleteAccountInput!
    $condition: ModelAccountConditionInput
  ) {
    deleteAccount(input: $input, condition: $condition) {
      id
      owners
      users {
        nextToken
      }
      balanceAccounts {
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const createAccountHasUser = /* GraphQL */ `
  mutation CreateAccountHasUser(
    $input: CreateAccountHasUserInput!
    $condition: ModelAccountHasUserConditionInput
  ) {
    createAccountHasUser(input: $input, condition: $condition) {
      id
      accountId
      account {
        id
        owners
        createdAt
        updatedAt
      }
      userId
      user {
        id
        stripeId
        favoriteBonds
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateAccountHasUser = /* GraphQL */ `
  mutation UpdateAccountHasUser(
    $input: UpdateAccountHasUserInput!
    $condition: ModelAccountHasUserConditionInput
  ) {
    updateAccountHasUser(input: $input, condition: $condition) {
      id
      accountId
      account {
        id
        owners
        createdAt
        updatedAt
      }
      userId
      user {
        id
        stripeId
        favoriteBonds
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteAccountHasUser = /* GraphQL */ `
  mutation DeleteAccountHasUser(
    $input: DeleteAccountHasUserInput!
    $condition: ModelAccountHasUserConditionInput
  ) {
    deleteAccountHasUser(input: $input, condition: $condition) {
      id
      accountId
      account {
        id
        owners
        createdAt
        updatedAt
      }
      userId
      user {
        id
        stripeId
        favoriteBonds
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const createUser = /* GraphQL */ `
  mutation CreateUser(
    $input: CreateUserInput!
    $condition: ModelUserConditionInput
  ) {
    createUser(input: $input, condition: $condition) {
      id
      accounts {
        nextToken
      }
      stripeId
      favoriteBonds
      createdAt
      updatedAt
    }
  }
`;
export const updateUser = /* GraphQL */ `
  mutation UpdateUser(
    $input: UpdateUserInput!
    $condition: ModelUserConditionInput
  ) {
    updateUser(input: $input, condition: $condition) {
      id
      accounts {
        nextToken
      }
      stripeId
      favoriteBonds
      createdAt
      updatedAt
    }
  }
`;
export const deleteUser = /* GraphQL */ `
  mutation DeleteUser(
    $input: DeleteUserInput!
    $condition: ModelUserConditionInput
  ) {
    deleteUser(input: $input, condition: $condition) {
      id
      accounts {
        nextToken
      }
      stripeId
      favoriteBonds
      createdAt
      updatedAt
    }
  }
`;
export const createBalanceAccount = /* GraphQL */ `
  mutation CreateBalanceAccount(
    $input: CreateBalanceAccountInput!
    $condition: ModelBalanceAccountConditionInput
  ) {
    createBalanceAccount(input: $input, condition: $condition) {
      id
      accountId
      account {
        id
        owners
        createdAt
        updatedAt
      }
      currency
      bondId
      bond {
        id
        cusip
        isin
        currency
        issuerId
        couponPayment
        outstandingAmount
        minimumPiece
        minimumIncrement
        isSecRegisteredSecurity
        paymentRank
        couponType
        bidAmount
        offerAmount
        benchmark
        spreadToBenchmark
        accruedDays
        accruedInterest
        timezone
        interpolatedCDRate
        industry
        esgScore
        couponFrequency
        makeWholeCall
        createdAt
        updatedAt
      }
      transactions {
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateBalanceAccount = /* GraphQL */ `
  mutation UpdateBalanceAccount(
    $input: UpdateBalanceAccountInput!
    $condition: ModelBalanceAccountConditionInput
  ) {
    updateBalanceAccount(input: $input, condition: $condition) {
      id
      accountId
      account {
        id
        owners
        createdAt
        updatedAt
      }
      currency
      bondId
      bond {
        id
        cusip
        isin
        currency
        issuerId
        couponPayment
        outstandingAmount
        minimumPiece
        minimumIncrement
        isSecRegisteredSecurity
        paymentRank
        couponType
        bidAmount
        offerAmount
        benchmark
        spreadToBenchmark
        accruedDays
        accruedInterest
        timezone
        interpolatedCDRate
        industry
        esgScore
        couponFrequency
        makeWholeCall
        createdAt
        updatedAt
      }
      transactions {
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteBalanceAccount = /* GraphQL */ `
  mutation DeleteBalanceAccount(
    $input: DeleteBalanceAccountInput!
    $condition: ModelBalanceAccountConditionInput
  ) {
    deleteBalanceAccount(input: $input, condition: $condition) {
      id
      accountId
      account {
        id
        owners
        createdAt
        updatedAt
      }
      currency
      bondId
      bond {
        id
        cusip
        isin
        currency
        issuerId
        couponPayment
        outstandingAmount
        minimumPiece
        minimumIncrement
        isSecRegisteredSecurity
        paymentRank
        couponType
        bidAmount
        offerAmount
        benchmark
        spreadToBenchmark
        accruedDays
        accruedInterest
        timezone
        interpolatedCDRate
        industry
        esgScore
        couponFrequency
        makeWholeCall
        createdAt
        updatedAt
      }
      transactions {
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const createTransaction = /* GraphQL */ `
  mutation CreateTransaction(
    $input: CreateTransactionInput!
    $condition: ModelTransactionConditionInput
  ) {
    createTransaction(input: $input, condition: $condition) {
      id
      accountId
      previousTransactionId
      order
      transactedAt
      balanceAccountId
      balanceAccount {
        id
        accountId
        currency
        bondId
        createdAt
        updatedAt
      }
      source
      type
      amountChange
      disponibleAmountChange
      orderTicketId
      orderTicket {
        id
        accountId
        direction
        balanceAccountId
        bondId
        faceAmount
        bondPrice
        minimumFillSize
        status
        statusLastChangeByUserId
        cancelReason
        isConfirmed
        confirmedByTraderId
        confirmedAt
        closingTradeTicketId
        loadedYield
        isImmediate
        timeInForce
        expiresAt
        createdAt
        updatedAt
      }
      tradeTicketId
      tradeTicket {
        id
        accountId
        orderTicketId
        amount
        bondPrice
        accruedDays
        accruedInterest
        tradeDate
        settlementDate
        isClosed
        finalCommissionAmount
        loadedYield
        createdAt
        updatedAt
      }
      complementaryTransactionId
      balance
      disponibleBalance
      createdAt
      updatedAt
    }
  }
`;
export const updateTransaction = /* GraphQL */ `
  mutation UpdateTransaction(
    $input: UpdateTransactionInput!
    $condition: ModelTransactionConditionInput
  ) {
    updateTransaction(input: $input, condition: $condition) {
      id
      accountId
      previousTransactionId
      order
      transactedAt
      balanceAccountId
      balanceAccount {
        id
        accountId
        currency
        bondId
        createdAt
        updatedAt
      }
      source
      type
      amountChange
      disponibleAmountChange
      orderTicketId
      orderTicket {
        id
        accountId
        direction
        balanceAccountId
        bondId
        faceAmount
        bondPrice
        minimumFillSize
        status
        statusLastChangeByUserId
        cancelReason
        isConfirmed
        confirmedByTraderId
        confirmedAt
        closingTradeTicketId
        loadedYield
        isImmediate
        timeInForce
        expiresAt
        createdAt
        updatedAt
      }
      tradeTicketId
      tradeTicket {
        id
        accountId
        orderTicketId
        amount
        bondPrice
        accruedDays
        accruedInterest
        tradeDate
        settlementDate
        isClosed
        finalCommissionAmount
        loadedYield
        createdAt
        updatedAt
      }
      complementaryTransactionId
      balance
      disponibleBalance
      createdAt
      updatedAt
    }
  }
`;
export const deleteTransaction = /* GraphQL */ `
  mutation DeleteTransaction(
    $input: DeleteTransactionInput!
    $condition: ModelTransactionConditionInput
  ) {
    deleteTransaction(input: $input, condition: $condition) {
      id
      accountId
      previousTransactionId
      order
      transactedAt
      balanceAccountId
      balanceAccount {
        id
        accountId
        currency
        bondId
        createdAt
        updatedAt
      }
      source
      type
      amountChange
      disponibleAmountChange
      orderTicketId
      orderTicket {
        id
        accountId
        direction
        balanceAccountId
        bondId
        faceAmount
        bondPrice
        minimumFillSize
        status
        statusLastChangeByUserId
        cancelReason
        isConfirmed
        confirmedByTraderId
        confirmedAt
        closingTradeTicketId
        loadedYield
        isImmediate
        timeInForce
        expiresAt
        createdAt
        updatedAt
      }
      tradeTicketId
      tradeTicket {
        id
        accountId
        orderTicketId
        amount
        bondPrice
        accruedDays
        accruedInterest
        tradeDate
        settlementDate
        isClosed
        finalCommissionAmount
        loadedYield
        createdAt
        updatedAt
      }
      complementaryTransactionId
      balance
      disponibleBalance
      createdAt
      updatedAt
    }
  }
`;
export const createTradeTicket = /* GraphQL */ `
  mutation CreateTradeTicket(
    $input: CreateTradeTicketInput!
    $condition: ModelTradeTicketConditionInput
  ) {
    createTradeTicket(input: $input, condition: $condition) {
      id
      accountId
      orderTicketId
      orderTicket {
        id
        accountId
        direction
        balanceAccountId
        bondId
        faceAmount
        bondPrice
        minimumFillSize
        status
        statusLastChangeByUserId
        cancelReason
        isConfirmed
        confirmedByTraderId
        confirmedAt
        closingTradeTicketId
        loadedYield
        isImmediate
        timeInForce
        expiresAt
        createdAt
        updatedAt
      }
      amount
      bondPrice
      accruedDays
      accruedInterest
      tradeDate
      settlementDate
      closingOrderTickets {
        nextToken
      }
      isClosed
      finalCommissionAmount
      loadedYield
      createdAt
      updatedAt
    }
  }
`;
export const updateTradeTicket = /* GraphQL */ `
  mutation UpdateTradeTicket(
    $input: UpdateTradeTicketInput!
    $condition: ModelTradeTicketConditionInput
  ) {
    updateTradeTicket(input: $input, condition: $condition) {
      id
      accountId
      orderTicketId
      orderTicket {
        id
        accountId
        direction
        balanceAccountId
        bondId
        faceAmount
        bondPrice
        minimumFillSize
        status
        statusLastChangeByUserId
        cancelReason
        isConfirmed
        confirmedByTraderId
        confirmedAt
        closingTradeTicketId
        loadedYield
        isImmediate
        timeInForce
        expiresAt
        createdAt
        updatedAt
      }
      amount
      bondPrice
      accruedDays
      accruedInterest
      tradeDate
      settlementDate
      closingOrderTickets {
        nextToken
      }
      isClosed
      finalCommissionAmount
      loadedYield
      createdAt
      updatedAt
    }
  }
`;
export const deleteTradeTicket = /* GraphQL */ `
  mutation DeleteTradeTicket(
    $input: DeleteTradeTicketInput!
    $condition: ModelTradeTicketConditionInput
  ) {
    deleteTradeTicket(input: $input, condition: $condition) {
      id
      accountId
      orderTicketId
      orderTicket {
        id
        accountId
        direction
        balanceAccountId
        bondId
        faceAmount
        bondPrice
        minimumFillSize
        status
        statusLastChangeByUserId
        cancelReason
        isConfirmed
        confirmedByTraderId
        confirmedAt
        closingTradeTicketId
        loadedYield
        isImmediate
        timeInForce
        expiresAt
        createdAt
        updatedAt
      }
      amount
      bondPrice
      accruedDays
      accruedInterest
      tradeDate
      settlementDate
      closingOrderTickets {
        nextToken
      }
      isClosed
      finalCommissionAmount
      loadedYield
      createdAt
      updatedAt
    }
  }
`;
export const createOrderTicket = /* GraphQL */ `
  mutation CreateOrderTicket(
    $input: CreateOrderTicketInput!
    $condition: ModelOrderTicketConditionInput
  ) {
    createOrderTicket(input: $input, condition: $condition) {
      id
      accountId
      direction
      balanceAccountId
      balanceAccount {
        id
        accountId
        currency
        bondId
        createdAt
        updatedAt
      }
      bondId
      bond {
        id
        cusip
        isin
        currency
        issuerId
        couponPayment
        outstandingAmount
        minimumPiece
        minimumIncrement
        isSecRegisteredSecurity
        paymentRank
        couponType
        bidAmount
        offerAmount
        benchmark
        spreadToBenchmark
        accruedDays
        accruedInterest
        timezone
        interpolatedCDRate
        industry
        esgScore
        couponFrequency
        makeWholeCall
        createdAt
        updatedAt
      }
      faceAmount
      bondPrice
      minimumFillSize
      status
      statusLastChangeByUserId
      cancelReason
      isConfirmed
      confirmedByTraderId
      confirmedAt
      closingTradeTicketId
      tradeTickets {
        nextToken
      }
      appliedCommissionRate {
        amount
        rate
      }
      loadedYield
      isImmediate
      timeInForce
      expiresAt
      createdAt
      updatedAt
    }
  }
`;
export const updateOrderTicket = /* GraphQL */ `
  mutation UpdateOrderTicket(
    $input: UpdateOrderTicketInput!
    $condition: ModelOrderTicketConditionInput
  ) {
    updateOrderTicket(input: $input, condition: $condition) {
      id
      accountId
      direction
      balanceAccountId
      balanceAccount {
        id
        accountId
        currency
        bondId
        createdAt
        updatedAt
      }
      bondId
      bond {
        id
        cusip
        isin
        currency
        issuerId
        couponPayment
        outstandingAmount
        minimumPiece
        minimumIncrement
        isSecRegisteredSecurity
        paymentRank
        couponType
        bidAmount
        offerAmount
        benchmark
        spreadToBenchmark
        accruedDays
        accruedInterest
        timezone
        interpolatedCDRate
        industry
        esgScore
        couponFrequency
        makeWholeCall
        createdAt
        updatedAt
      }
      faceAmount
      bondPrice
      minimumFillSize
      status
      statusLastChangeByUserId
      cancelReason
      isConfirmed
      confirmedByTraderId
      confirmedAt
      closingTradeTicketId
      tradeTickets {
        nextToken
      }
      appliedCommissionRate {
        amount
        rate
      }
      loadedYield
      isImmediate
      timeInForce
      expiresAt
      createdAt
      updatedAt
    }
  }
`;
export const deleteOrderTicket = /* GraphQL */ `
  mutation DeleteOrderTicket(
    $input: DeleteOrderTicketInput!
    $condition: ModelOrderTicketConditionInput
  ) {
    deleteOrderTicket(input: $input, condition: $condition) {
      id
      accountId
      direction
      balanceAccountId
      balanceAccount {
        id
        accountId
        currency
        bondId
        createdAt
        updatedAt
      }
      bondId
      bond {
        id
        cusip
        isin
        currency
        issuerId
        couponPayment
        outstandingAmount
        minimumPiece
        minimumIncrement
        isSecRegisteredSecurity
        paymentRank
        couponType
        bidAmount
        offerAmount
        benchmark
        spreadToBenchmark
        accruedDays
        accruedInterest
        timezone
        interpolatedCDRate
        industry
        esgScore
        couponFrequency
        makeWholeCall
        createdAt
        updatedAt
      }
      faceAmount
      bondPrice
      minimumFillSize
      status
      statusLastChangeByUserId
      cancelReason
      isConfirmed
      confirmedByTraderId
      confirmedAt
      closingTradeTicketId
      tradeTickets {
        nextToken
      }
      appliedCommissionRate {
        amount
        rate
      }
      loadedYield
      isImmediate
      timeInForce
      expiresAt
      createdAt
      updatedAt
    }
  }
`;
export const createRateCommission = /* GraphQL */ `
  mutation CreateRateCommission(
    $input: CreateRateCommissionInput!
    $condition: ModelRateCommissionConditionInput
  ) {
    createRateCommission(input: $input, condition: $condition) {
      id
      currency
      amount
      rate
      createdAt
      updatedAt
    }
  }
`;
export const updateRateCommission = /* GraphQL */ `
  mutation UpdateRateCommission(
    $input: UpdateRateCommissionInput!
    $condition: ModelRateCommissionConditionInput
  ) {
    updateRateCommission(input: $input, condition: $condition) {
      id
      currency
      amount
      rate
      createdAt
      updatedAt
    }
  }
`;
export const deleteRateCommission = /* GraphQL */ `
  mutation DeleteRateCommission(
    $input: DeleteRateCommissionInput!
    $condition: ModelRateCommissionConditionInput
  ) {
    deleteRateCommission(input: $input, condition: $condition) {
      id
      currency
      amount
      rate
      createdAt
      updatedAt
    }
  }
`;
export const createBond = /* GraphQL */ `
  mutation CreateBond(
    $input: CreateBondInput!
    $condition: ModelBondConditionInput
  ) {
    createBond(input: $input, condition: $condition) {
      id
      cusip
      isin
      currency
      issuerId
      issuer {
        id
        name
        ticker
        createdAt
        updatedAt
      }
      couponPayment
      outstandingAmount
      minimumPiece
      minimumIncrement
      isSecRegisteredSecurity
      ratings {
        nextToken
      }
      callDates {
        price
        callDate
      }
      paymentRank
      couponType
      maturity {
        date
        maturityType
        nextCallDate
        nextCallPrice
      }
      bidAmount
      offerAmount
      benchmark
      spreadToBenchmark
      accruedDays
      accruedInterest
      timezone
      interpolatedCDRate
      industry
      esgScore
      couponFrequency
      makeWholeCall
      createdAt
      updatedAt
    }
  }
`;
export const updateBond = /* GraphQL */ `
  mutation UpdateBond(
    $input: UpdateBondInput!
    $condition: ModelBondConditionInput
  ) {
    updateBond(input: $input, condition: $condition) {
      id
      cusip
      isin
      currency
      issuerId
      issuer {
        id
        name
        ticker
        createdAt
        updatedAt
      }
      couponPayment
      outstandingAmount
      minimumPiece
      minimumIncrement
      isSecRegisteredSecurity
      ratings {
        nextToken
      }
      callDates {
        price
        callDate
      }
      paymentRank
      couponType
      maturity {
        date
        maturityType
        nextCallDate
        nextCallPrice
      }
      bidAmount
      offerAmount
      benchmark
      spreadToBenchmark
      accruedDays
      accruedInterest
      timezone
      interpolatedCDRate
      industry
      esgScore
      couponFrequency
      makeWholeCall
      createdAt
      updatedAt
    }
  }
`;
export const deleteBond = /* GraphQL */ `
  mutation DeleteBond(
    $input: DeleteBondInput!
    $condition: ModelBondConditionInput
  ) {
    deleteBond(input: $input, condition: $condition) {
      id
      cusip
      isin
      currency
      issuerId
      issuer {
        id
        name
        ticker
        createdAt
        updatedAt
      }
      couponPayment
      outstandingAmount
      minimumPiece
      minimumIncrement
      isSecRegisteredSecurity
      ratings {
        nextToken
      }
      callDates {
        price
        callDate
      }
      paymentRank
      couponType
      maturity {
        date
        maturityType
        nextCallDate
        nextCallPrice
      }
      bidAmount
      offerAmount
      benchmark
      spreadToBenchmark
      accruedDays
      accruedInterest
      timezone
      interpolatedCDRate
      industry
      esgScore
      couponFrequency
      makeWholeCall
      createdAt
      updatedAt
    }
  }
`;
export const createIssuer = /* GraphQL */ `
  mutation CreateIssuer(
    $input: CreateIssuerInput!
    $condition: ModelIssuerConditionInput
  ) {
    createIssuer(input: $input, condition: $condition) {
      id
      name
      ticker
      bonds {
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateIssuer = /* GraphQL */ `
  mutation UpdateIssuer(
    $input: UpdateIssuerInput!
    $condition: ModelIssuerConditionInput
  ) {
    updateIssuer(input: $input, condition: $condition) {
      id
      name
      ticker
      bonds {
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteIssuer = /* GraphQL */ `
  mutation DeleteIssuer(
    $input: DeleteIssuerInput!
    $condition: ModelIssuerConditionInput
  ) {
    deleteIssuer(input: $input, condition: $condition) {
      id
      name
      ticker
      bonds {
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const createBondRating = /* GraphQL */ `
  mutation CreateBondRating(
    $input: CreateBondRatingInput!
    $condition: ModelBondRatingConditionInput
  ) {
    createBondRating(input: $input, condition: $condition) {
      id
      bondId
      bond {
        id
        cusip
        isin
        currency
        issuerId
        couponPayment
        outstandingAmount
        minimumPiece
        minimumIncrement
        isSecRegisteredSecurity
        paymentRank
        couponType
        bidAmount
        offerAmount
        benchmark
        spreadToBenchmark
        accruedDays
        accruedInterest
        timezone
        interpolatedCDRate
        industry
        esgScore
        couponFrequency
        makeWholeCall
        createdAt
        updatedAt
      }
      ratingId
      rating {
        id
        value
        order
        agencyId
        createdAt
        updatedAt
      }
      watch
      createdAt
      updatedAt
    }
  }
`;
export const updateBondRating = /* GraphQL */ `
  mutation UpdateBondRating(
    $input: UpdateBondRatingInput!
    $condition: ModelBondRatingConditionInput
  ) {
    updateBondRating(input: $input, condition: $condition) {
      id
      bondId
      bond {
        id
        cusip
        isin
        currency
        issuerId
        couponPayment
        outstandingAmount
        minimumPiece
        minimumIncrement
        isSecRegisteredSecurity
        paymentRank
        couponType
        bidAmount
        offerAmount
        benchmark
        spreadToBenchmark
        accruedDays
        accruedInterest
        timezone
        interpolatedCDRate
        industry
        esgScore
        couponFrequency
        makeWholeCall
        createdAt
        updatedAt
      }
      ratingId
      rating {
        id
        value
        order
        agencyId
        createdAt
        updatedAt
      }
      watch
      createdAt
      updatedAt
    }
  }
`;
export const deleteBondRating = /* GraphQL */ `
  mutation DeleteBondRating(
    $input: DeleteBondRatingInput!
    $condition: ModelBondRatingConditionInput
  ) {
    deleteBondRating(input: $input, condition: $condition) {
      id
      bondId
      bond {
        id
        cusip
        isin
        currency
        issuerId
        couponPayment
        outstandingAmount
        minimumPiece
        minimumIncrement
        isSecRegisteredSecurity
        paymentRank
        couponType
        bidAmount
        offerAmount
        benchmark
        spreadToBenchmark
        accruedDays
        accruedInterest
        timezone
        interpolatedCDRate
        industry
        esgScore
        couponFrequency
        makeWholeCall
        createdAt
        updatedAt
      }
      ratingId
      rating {
        id
        value
        order
        agencyId
        createdAt
        updatedAt
      }
      watch
      createdAt
      updatedAt
    }
  }
`;
export const createRating = /* GraphQL */ `
  mutation CreateRating(
    $input: CreateRatingInput!
    $condition: ModelRatingConditionInput
  ) {
    createRating(input: $input, condition: $condition) {
      id
      value
      order
      agencyId
      agency {
        id
        name
        createdAt
        updatedAt
      }
      bondRatings {
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateRating = /* GraphQL */ `
  mutation UpdateRating(
    $input: UpdateRatingInput!
    $condition: ModelRatingConditionInput
  ) {
    updateRating(input: $input, condition: $condition) {
      id
      value
      order
      agencyId
      agency {
        id
        name
        createdAt
        updatedAt
      }
      bondRatings {
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteRating = /* GraphQL */ `
  mutation DeleteRating(
    $input: DeleteRatingInput!
    $condition: ModelRatingConditionInput
  ) {
    deleteRating(input: $input, condition: $condition) {
      id
      value
      order
      agencyId
      agency {
        id
        name
        createdAt
        updatedAt
      }
      bondRatings {
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const createRatingAgency = /* GraphQL */ `
  mutation CreateRatingAgency(
    $input: CreateRatingAgencyInput!
    $condition: ModelRatingAgencyConditionInput
  ) {
    createRatingAgency(input: $input, condition: $condition) {
      id
      name
      ratings {
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateRatingAgency = /* GraphQL */ `
  mutation UpdateRatingAgency(
    $input: UpdateRatingAgencyInput!
    $condition: ModelRatingAgencyConditionInput
  ) {
    updateRatingAgency(input: $input, condition: $condition) {
      id
      name
      ratings {
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteRatingAgency = /* GraphQL */ `
  mutation DeleteRatingAgency(
    $input: DeleteRatingAgencyInput!
    $condition: ModelRatingAgencyConditionInput
  ) {
    deleteRatingAgency(input: $input, condition: $condition) {
      id
      name
      ratings {
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
